import styled from "styled-components";

export const InputVideoWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  video {
    object-fit: cover;
    border-radius: 5px;
    box-shadow: rgba(199, 199, 199, 0.71) 0px 1px 4px;
  }
`;

export const InputPhoto = styled.img`
  display: flex;
  object-fit: cover;
  max-width: none;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  box-shadow: rgba(199, 199, 199, 0.71) 0px 1px 4px;
`;

export const PlayIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px 0 0 -10px;
  width: 20px;
  height: 20px;
  transition: all 0.2s;
  ${(props) =>
    props.show
      ? `
    opacity: 0.8;
  `
      : `
    opacity: 0;
  `};
`;
